function generateGradient(startColor, steps) {
  let colors = [startColor];
  let currentColor = startColor;

  for (let i = 0; i < steps; i++) {
    currentColor = getNextColor(currentColor);
    colors.push(currentColor);
  }

  return colors;
}

function getNextColor(hex) {
  let parts = hex.match(/#(..)(..)(..)/).slice(1);
  let [r, g, b] = parts.map((part) => parseInt(part, 16));

  if (b < 255) {
    b++;
  } else if (g < 255) {
    g++;
    b = 240;
  } else if (r < 255) {
    r++;
    g = 245;
    b = 245;
  }

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

function toHex(value) {
  return value.toString(16).padStart(2, '0');
}

const BG_COLORS = generateGradient('#fbfff5', 50);

export default BG_COLORS;
